// @figma file=tbd node=tbd name="SessionStatsCard" set="araf-analytics" verified=tbd
import { UsersIcon } from 'lucide-react';
import * as React from 'react';
import { StatCard } from '../components/atoms/stat-card';
import { cn } from '../lib/utils';

// ─── Props ────────────────────────────────────────────────────────────────────

export interface SessionStatsCardProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Number of currently active sessions */
  count: number;
  /**
   * Tenant scope label. Pass undefined to show "across all tenants".
   */
  tenantSlug?: string;
  /** Render skeleton */
  isLoading?: boolean;
}

// ─── Component ────────────────────────────────────────────────────────────────

const SessionStatsCard = React.forwardRef<HTMLDivElement, SessionStatsCardProps>(
  ({ count, tenantSlug, isLoading = false, className, ...props }, ref) => {
    const sublabel = tenantSlug ? `Active in ${tenantSlug}` : 'Active across all tenants';

    return (
      <StatCard
        ref={ref}
        className={cn(className)}
        label="Active sessions"
        value={count}
        sublabel={sublabel}
        icon={<UsersIcon />}
        variant="info"
        loading={isLoading}
        {...props}
      />
    );
  },
);
SessionStatsCard.displayName = 'SessionStatsCard';

export { SessionStatsCard };
